<template>
  <div>
    <el-tabs @tab-click="tabClick" v-model="currentTabName">
      <el-tab-pane label="基本信息" name="basic">
        <form data-vv-scope="editUserForm">
          <table class="form-table" cellspacing="0" cellpadding="0" border="0">
            <tbody>
              <tr>
                <td class="is-required">姓名:</td>
                <td>
                  <eco-input v-model="user.fullname" autocomplete="off" :validate="{ required: true }"></eco-input>
                </td>
                <td class="is-required">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <p>账号只能输入英文字母、数字，最少2位<br /></p>
                    </div>
                    <i class="el-icon-question" /> </el-tooltip
                  >账号:
                </td>
                <td>
                  <eco-input
                    v-model="user.account"
                    autocomplete="off"
                    :disabled="account != ''"
                    v-pinyin:1="user.fullname"
                    :validate="{
                      regex: {
                        exp: '^[a-zA-Z0-9_-]{2,20}$',
                        message: '账号只能输入英文字母、数字，最少2位'
                      }
                    }"
                  ></eco-input>
                </td>
                <td rowspan="4" align="center" valign="middle">
                  <el-avatar :size="120" :src="photoUrl">
                    <img :src="photoUrl" />
                  </el-avatar>
                  <el-upload action="string" :http-request="updateUserImage" :show-file-list="false" accept=".jpg,.jpeg,.png">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                </td>
              </tr>
              <tr>
                <td v-if="account != ''">手机:</td>
                <td v-if="account != ''">
                  <eco-input v-model="user.mobile" autocomplete="off" validate="mobile"></eco-input>
                  <el-button type="primary" style="margin-left: 15px; line-height: 10px" @click="transfor(1)" v-if="transforDing">同步钉钉</el-button>
                </td>
                <td v-if="account == ''" class="is-required">密码:</td>
                <td v-if="account == ''">
                  <eco-input v-model="user.password" show-password :validate="pwdValidate" />
                </td>
                <td>邮箱:</td>
                <td>
                  <eco-input
                    v-model="user.email"
                    autocomplete="off"
                    :validate="{
                      regex: {
                        exp: '^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$',
                        message: '邮箱格式不正确'
                      }
                    }"
                  ></eco-input>
                </td>
              </tr>
              <tr>
                <td>性别:</td>
                <td>
                  <eco-select
                    v-model="user.sex"
                    :options="[
                      { key: '男', value: '男' },
                      { key: '女', value: '女' }
                    ]"
                  />
                </td>
                <td>地址:</td>
                <td>
                  <eco-input v-model="user.address" autocomplete="off"></eco-input>
                </td>
              </tr>
              <tr>
                <td>状态:</td>
                <td>
                  <eco-select
                    v-model="user.status"
                    :validate="{ required: true }"
                    :options="[
                      { key: 0, value: '禁用' },
                      { key: 1, value: '正常' },
                      { key: -2, value: '离职' }
                    ]"
                  />
                </td>
                <td v-if="account != ''">微信帐号:</td>
                <td v-if="account != ''">
                  <eco-input :readonly="true" v-model="user.weixin" autocomplete="off"></eco-input>
                  <el-button type="primary" style="margin-left: 15px; line-height: 10px" @click="transfor(2)" v-if="transforWeChat">同步企业微信</el-button>
                  <el-button type="primary" style="margin-left: 15px; line-height: 10px" @click="transfor(3)" v-if="transforWeChatOff"
                    >同步微信公众号</el-button
                  >
                </td>
                <td v-if="account == ''">手机:</td>
                <td v-if="account == ''">
                  <eco-input v-model="user.mobile" autocomplete="off" validate="mobile"></eco-input>
                </td>
                <td v-if="account != ''" colspan="2"></td>
              </tr>
              <tr>
                <td colspan="5" align="center">
                  <fe-submit-button
                    :url="saveUserUrl"
                    :model="user"
                    :is-submit="isSubmit"
                    scope-name="editUserForm"
                    @before-save-data="beforeSaveData"
                    @after-save-data="afterSaveData"
                    >{{ $t('eip.common.save') }}</fe-submit-button
                  >
                  <el-button @click="closeUserManager">{{ $t('eip.common.cancel') }}</el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </el-tab-pane>
      <el-tab-pane label="所属组织岗位" name="orgPost" :disabled="account == ''">
        <div style="height: calc(100vh - 200px)">
          <eco-table
            @load="orgPostData"
            v-if="userOrgPostLoaded"
            :data="orgPostList"
            :pageResult="orgPostPageResult"
            :selection="true"
            :show-export="false"
            :show-custom-column="false"
            :default-querys="[{ property: 'account', value: account }]"
            ref="orgPostTables"
          >
            <template v-slot:toolbar>
              <el-button size="small" type="primary" @click="showEipOrgDialog">添加组织</el-button>
              <el-button size="small" type="primary" @click="showEipPostDialog">添加岗位</el-button>
              <fe-delete-button :url="delOrgUser" :htTable="$refs.orgPostTables" @after-delete="afterDelOrgUser" pk="orgUserId">删除</fe-delete-button>
            </template>
            <template>
              <eco-table-column type="index" width="50" align="center" label="序号" />
              <eco-table-column prop="demName" label="组织维度" width="160" />
              <eco-table-column prop="orgName" label="组织名称" />
              <eco-table-column prop="pathName" label="组织路径" />
              <eco-table-column prop="posName" label="岗位名称" />
              <eco-table-column prop="isMaster" label="主组织/主岗位" width="100">
                <template v-slot="{ row }">
                  <el-tag type="danger" v-if="row.isMaster == '0'">否</el-tag>
                  <el-tag v-if="row.isMaster == '1'">是</el-tag>
                </template>
              </eco-table-column>
              <eco-table-column label="操作" width="300">
                <template v-slot="{ row }">
                  <el-link type="primary" v-if="row.isMaster == 0 && row.posName" :underline="false" @click="setMaster(row)">设置主岗位</el-link>
                  <el-link type="primary" :underline="false" v-if="row.isMaster == 1 && row.posName" @click="setMaster(row)">取消主岗位</el-link>
                  <el-link type="primary" :underline="false" v-if="row.isMaster == 0 && !row.posName" @click="setMaster(row)">设置主组织</el-link>
                  <el-link :underline="false" type="primary" v-if="row.isMaster == 1 && !row.posName" @click="setMaster(row)">取消主组织</el-link>
                </template>
              </eco-table-column>
            </template>
          </eco-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="所属角色" name="role" :disabled="account == ''">
        <div style="height: calc(100vh - 200px)">
          <eco-table
            @load="userRoleLoad"
            :data="userRoleList"
            v-if="userRoleLoaded"
            :pageResult="rolePageResult"
            :selection="true"
            :show-export="false"
            :show-custom-column="false"
            :default-querys="[{ property: 'u.account_', value: account }]"
            ref="userRoleTable"
          >
            <template v-slot:toolbar>
              <el-button-group>
                <el-button size="small" @click="showEipRoleDialog" icon="el-icon-plus">添加角色</el-button>
              </el-button-group>
            </template>
            <template>
              <eco-table-column type="index" width="50" align="center" label="序号" />
              <eco-table-column prop="roleName" label="名称" />
              <eco-table-column prop="alias" label="编码" width="300" />
              <eco-table-column width="154" label="操作">
                <template v-slot="{ row }">
                  <el-button type="danger" icon="el-icon-delete" @click="deleteUserRole(row.alias)">删除</el-button>
                </template>
              </eco-table-column>
            </template>
          </eco-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="用户参数" name="param" :disabled="account == ''">
        <el-form v-model="userParam" class="user-param-form">
          <template v-for="param in userParams">
            <eco-form-item :label="param.name" prop="name" label-width="200px" :key="param.name">
              <el-date-picker v-model="userParam[param.code]" type="datetime" placeholder="选择日期时间" v-if="param.ctlType === 'date'"></el-date-picker>
              <eco-input v-model="userParam[param.code]" v-if="param.ctlType === 'input'" />
              <eco-input type="number" v-model="userParam[param.code]" v-if="param.ctlType === 'number'" />
              <eco-select v-model="userParam[param.code]" v-if="param.ctlType === 'select'" :options="JSON.parse(param.json)" />
              <eco-radio v-model="userParam[param.code]" v-if="param.ctlType === 'radio'" :options="JSON.parse(param.json)" />
              <eco-checkbox v-model="userParam[param.code]" v-if="param.ctlType === 'checkbox'" :options="JSON.parse(param.json)" />
            </eco-form-item>
          </template>
        </el-form>
        <el-row>
          <el-col :offset="6">
            <el-button type="primary" @click="userParamSubmit">保存</el-button>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <!-- 组织选择对话框  -->
    <eip-org-dialog ref="eipOrgDialog" @onConfirm="addUserOrg" append-to-body />
    <!-- 岗位选择对话框  -->
    <eip-post-dialog ref="eipPostDialog" @onConfirm="addUserPost" append-to-body />
    <!-- 角色选择对话框  -->
    <eip-role-dialog ref="eipRoleDialog" @onConfirm="addUserRole" append-to-body />

    <!-- 微信同步对话框  -->
    <wx-dialog
      ref="wxDialog"
      append-to-body
      :single="true"
      :treeData="wxOrgData"
      :data="wxUserData"
      :props="{ children: 'children', label: 'name', isLeaf: 'leaf' }"
      :table-columns="wxTableColumns"
      @load="wxLoaded"
      @onConfirm="wxConfirm"
      @nodeClick="wxTreeNodeClick"
    />
  </div>
</template>

<script>
import utils from '@/eco-ui-util.js'
import uc from '@/api/uc.js'
import org from '@/api/org.js'
import sys from '@/api/portal.js'
import req from '@/request.js'
import eipOrgDialog from '@/components/dialog/EipOrgDialog.vue'
import eipPostDialog from '@/components/dialog/EipPostDialog.vue'
import portal from '@/api/portal.js'
const eipRoleDialog = () => import('@/components/dialog/EipRoleDialog.vue')
const wxDialog = () => import('@/components/dialog/WxDialog.vue')

export default {
  name: 'UserManager',
  components: {
    eipOrgDialog,
    eipPostDialog,
    eipRoleDialog,
    wxDialog
  },
  computed: {
    saveUserUrl: function () {
      let preUrl = window.context.uc + '/api/user/v1/user'
      if (this.account) {
        preUrl += '/updateUser'
      } else {
        preUrl += '/addUser'
      }
      return preUrl
    },
    delOrgUser: function () {
      return window.context.uc + '/api/org/v1/orgUser/delOrgUser'
    }
  },
  data() {
    return {
      user: {
        account: '',
        address: '',
        email: '',
        fullname: '',
        mobile: '',
        password: '',
        photo: '',
        sex: '',
        status: 1,
        dingUserId: '',
        weixin: ''
      },
      photoUrl: '/img/defaultPhoto.jpg',
      orgPostPageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      rolePageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      orgPostList: [], //组织岗位
      userRoleList: [], //用户角色,
      userParam: {}, //当前用户的用户参数值
      userParams: [], //系统的所有用户参数
      account: '',
      isSubmit: true,
      currentTabName: 'basic',
      userParamLoaded: false,
      userOrgPostLoaded: false,
      userRoleLoaded: false,
      pwdValidate: {
        required: true,
        min: 6
      },
      transforDing: false,
      transforWeChat: false,
      transforWeChatOff: false,
      wxOrgData: [],
      wxUserData: [],
      wxTableColumns: [
        { prop: 'name', label: '姓名' },
        { prop: 'userId', label: '微信ID' }
      ]
    }
  },
  props: ['userAccount'],
  mounted() {
    this.account = this.userAccount
    // 用户参数是否已加载
    this.userParamLoaded = false
    // 是否显示用户所属组织岗位
    this.userOrgPostLoaded = false
    // 是否显示用户拥有的角色
    this.userRoleLoaded = false
    if (this.account) {
      uc.getUser(this.account).then((resp) => {
        Object.assign(this.user, resp.user)
        if (this.user.photo) {
          this.$store.dispatch('menu/downloadImg', this.user.photo).then((res) => {
            if (res != '') {
              this.photoUrl = res
            }
          })
        }
      })
    }
    //默认密码策略
    uc.getDefaultPwdStrategy().then((data) => {
      if (data) {
        let form = data
        //默认初始化密码
        if (form.initPwd) {
          this.user.password = form.initPwd
        }
        if (form.enable == 1) {
          let pwdRule = form.pwdRule
          let pwdLength = form.pwdLength
          if (pwdRule == 1) {
            this.pwdValidate = {
              required: true,
              min: pwdLength
            }
          } else {
            let regex = {}
            if (pwdRule == 2) {
              regex = {
                exp: '^(?=.*[0-9])(?=.*[a-zA-Z]).{' + pwdLength + ',30}$',
                message: '密码必须包含字母、数字,至少' + pwdLength + '位'
              }
            } else if (pwdRule == 3) {
              regex = {
                exp: '^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{' + pwdLength + ',30}$',
                message: '密码必须包含数字、字母、特殊字符,至少' + pwdLength + '位'
              }
            } else if (pwdRule == 4) {
              regex = {
                exp: '^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{' + pwdLength + ',30}$',
                message: '密码必须包含数字、大小写字母、特殊字符,至少' + pwdLength + '位'
              }
            }
            this.pwdValidate = {
              required: true,
              regex: regex
            }
          }
        }
      }
    })
    //判断用户同步手机号
    let url = window.context.portal + '/portal/sysExternalUnite/v1/listJson'
    let param = {
      pageBean: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      querys: []
    }
    req.post(url, param).then((res) => {
      let response = res.data.rows
      response.forEach((item) => {
        if (item.type == 'dingtalk') {
          this.transforDing = true
        }
        if (item.type == 'weChatWork') {
          this.transforWeChat = true
        }
        if (item.type == 'weChatOffAcc') {
          this.transforWeChatOff = true
        }
      })
    })
  },
  methods: {
    transfor(num) {
      if (num == 1) {
        if (this.user.mobile == '') {
          this.$message.info('请先输入手机号！')
        } else {
          let url = window.context.portal + '/portal/sysExternalUnite/v1/getUserIdByMobile?type=dingtalk&mobile=' + this.user.mobile
          req.get(url).then((res) => {
            let response = res.data
            if (response.state) {
              this.user.dingUserId = response.value
              this.$message.info('同步成功！保存后生效！')
            } else {
              this.user.dingUserId = ''
            }
          })
        }
      } else if (num === 2) {
        if (this.user.mobile == '') {
          this.$message.info('请先输入手机号！')
        } else {
          let url = window.context.portal + '/portal/sysExternalUnite/v1/getUserIdByMobile?type=weChatWork&mobile=' + this.user.mobile
          req.get(url).then((res) => {
            let response = res.data
            if (response.state) {
              this.user.weixin = response.value
              this.$message.info('同步成功！保存后生效！')
            } else {
              this.user.weixin = ''
            }
          })
        }
        // this.$refs.wxDialog.showDialog();
        // this.wxLoadTree();
        // this.wxLoaded();
      }
    },
    phonoError(e) {
      // this.user.photo = "/img/defaultPhoto.jpg";
    },
    async beforeSaveData() {
      if (this.photo) {
        this.user.photo = this.photo
      }
      this.isSubmit = true
    },
    afterSaveData() {
      this.$confirm('操作成功, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.account = this.user.account
        })
        .catch(() => {
          //点击取消按钮
          this.$emit('handleCloseUserManager', false)
        })
    },
    updateUserImage(param) {
      const formData = new FormData()
      formData.append('files', param.file)
      uc.fileUpload(formData)
        .then((response) => {
          this.photo = response.fileId
          this.user.photo = response.fileId
          this.$store.dispatch('menu/downloadImg', response.fileId).then((res) => {
            if (res != '') {
              this.photoUrl = res
            }
          })
          param.onSuccess() // 上传成功的图片会显示绿色的对勾
        })
        .catch((response) => {
          param.onError()
        })
    },
    orgPostData(param, cb) {
      uc.getUserOrgPage(param)
        .then((response) => {
          this.orgPostList = response.rows
          this.orgPostPageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    setMaster(row) {
      let flag = false
      let orgName = ''
      this.orgPostList.forEach((item) => {
        if (item.isMaster === 1 && row.orgId !== item.orgId) {
          orgName = item.orgName
          flag = true
        }
      })
      if (flag) {
        this.$confirm('该用户已设置主组织' + orgName + '，是否重新设置？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        })
          .then(() => {
            uc.setMasterById(row.orgUserId).then((resp) => {
              this.$refs.orgPostTables.load()
            })
          })
          .catch(() => {})
      } else {
        uc.setMasterById(row.orgUserId).then((resp) => {
          this.$refs.orgPostTables.load()
        })
      }
    },
    showEipOrgDialog() {
      this.$refs.eipOrgDialog.showDialog()
    },
    showEipPostDialog() {
      this.$refs.eipPostDialog.showDialog()
    },
    checkBeyondOrg(orgCodes, callback) {
      org.getOrgLimitByCodes(orgCodes.join(',')).then((resp) => {
        let normalOrgCodes = []
        let beyondOrgs = []
        if (resp && resp.rows) {
          resp.rows.forEach((org) => {
            if (org.exceedLimitNum === 1 && org.limitNum != 0) {
              if (org.limitNum > org.nowNum + 1) {
                normalOrgCodes.push(org.code)
              } else {
                beyondOrgs.push(org)
              }
            } else {
              normalOrgCodes.push(org.code)
            }
          })
        }
        callback({ normal: normalOrgCodes, beyond: beyondOrgs })
      })
    },
    addUserOrg(param) {
      param = param.map((param) => {
        return param.code
      })
      let _this = this
      this.checkBeyondOrg(param, function (resp) {
        if (resp.beyond.length > 0) {
          let beyondOrgNames = resp.beyond.map((org) => {
            return org.name
          })
          _this.$message.error('添加失败：组织【' + beyondOrgNames.join(',') + '】超出限编')
          return
        }
        var params = {
          account: _this.account,
          orgCode: resp.normal
        }
        uc.saveUserOrgs(params).then((resp) => {
          _this.$refs.orgPostTables.load()
        })
      })
    },
    addUserPost(param) {
      param = param.map((param) => {
        return param.code
      })
      var params = {
        account: this.account,
        Code: param
      }
      uc.saveUserPosts(params).then((resp) => {
        this.$refs.orgPostTables.load()
      })
    },
    getOrg(_param) {
      org.getOrg(_param.orgCode).then((resp) => {
        if (resp.exceedLimitNum === 1 && resp.limitNum != 0) {
          if (resp.limitNum > resp.nowNum + 1) {
            return _param.code
          } else {
            isBeyond = true
          }
        } else {
          return _param.code
        }
      })
    },
    showEipRoleDialog() {
      this.$refs.eipRoleDialog.showDialog()
    },
    deleteOrgPost(id) {
      uc.delOrgUser(id).then(() => {
        this.$refs.orgPostTables.load()
      })
    },
    userRoleLoad(param, cb) {
      uc.userRolePage(param)
        .then((response) => {
          if (response) {
            this.userRoleList = response.rows
            this.rolePageResult = {
              page: response.page,
              pageSize: response.pageSize,
              total: response.total
            }
          }
        })
        .finally(() => cb())
    },
    deleteUserRole(code) {
      var params = {
        account: this.account,
        codes: code
      }
      uc.delUserRole(params).then(() => {
        this.$refs.userRoleTable.load()
      })
    },
    addUserRole(param) {
      param = param.map((param) => {
        return param.code
      })
      var params = {
        account: this.account,
        codes: param
      }
      uc.saveUserRoles(params).then(() => {
        this.$refs.userRoleTable.load()
      })
    },
    userParamSubmit() {
      var param = {
        account: this.user.account
      }
      var data = []
      for (var _param in this.userParam) {
        data.push({ alias: _param, value: this.userParam[_param] })
      }
      uc.saveUserParams(data, param).then((resp) => {
        this.$message({
          message: resp.message,
          type: 'success',
          showClose: true
        })
      })
    },
    closeUserManager() {
      // 调用父级方法关闭面板
      this.$emit('closeUserManeger')
    },
    // 点击某个tab页签时再加载该页签的数据
    tabClick() {
      switch (this.currentTabName) {
        case 'orgPost':
          this.userOrgPostLoaded = true
          break
        case 'role':
          this.userRoleLoaded = true
          break
        case 'param':
          // 获取用户参数
          if (!this.userParamLoaded && this.account) {
            uc.getUserParams()
              .then((resp) => {
                this.userParamLoaded = true
                this.userParams = resp
                return resp
              })
              .then((params) => {
                if (!params || params.constructor != Array || params.length < 1) {
                  return
                }
                uc.getUserParamsValue(this.account).then((response) => {
                  if (response && response.constructor == Array) {
                    response.forEach((r) => {
                      this.$set(this.userParam, r['alias'], r['value'])
                    })
                  }
                })
              })
          }
          break
      }
    },
    afterDelOrgUser() {
      this.$refs.orgPostTables.load()
    },
    wxLoaded(param, cb) {
      portal.getWxUserListByOrgId('1', 'weChatWork').then((req) => {
        req.forEach((data) => {
          data.id = data.userId
        })
        this.wxUserData = req
      })
      // 回调关闭loading
      cb()
    },
    wxConfirm(selectData) {
      this.user.weixin = selectData[0].userId
    },
    wxTreeNodeClick(data) {
      portal.getWxUserListByOrgId(data.id, 'weChatWork').then((req) => {
        req.forEach((data) => {
          data.id = data.userId
        })
        this.wxUserData = req
      })
    },
    wxLoadTree() {
      portal.getWxOrgList('weChatWork').then((req) => {
        this.wxOrgData = req
      })
    }
  }
}
</script>
<style scoped>
.user-param-form {
  min-height: 400px;
}
</style>
